export default __webpack_public_path__ + "static/media/nissan.75afe869.png";